if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');
      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      document.addEventListener('DOMContentLoaded', this.setTransparentClass.bind(this));

      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
          window.dispatchEvent(new Event('scroll'));
        } else {
          this.classList.add('is-sticky');
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
        document.querySelector('.product-information')?.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
    setTransparentClass() {
      this.template_header = document.querySelector('.template-header');

      if (this.template_header && this.template_header.classList.contains('template-header--has-image-true') && this.template_header.dataset.sectionIndex == 1) {
        this.classList.remove('transparent--false');
        this.classList.add('transparent--true');
      }
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.header = this.closest('.header');
      this.toggle = this.querySelector('.full-menu--toggle');
      this.items = this.querySelectorAll('.full-menu--item');
      this.menu = this.querySelector('.full-menu--menu');
      this.backdrop = this.querySelector('.full-menu--backdrop');
    }
    connectedCallback() {
      if (this.toggle) {
        this.toggle.addEventListener('click', this.onToggleClick.bind(this));
      }

      this.items.forEach((item) => {
        const link = item.querySelector('.full-menu--link-parent');
        const subMenu = item.querySelector('.full-menu--sub-links');
        if (!subMenu || !link) return;

        // Toggle on click for hash or placeholder links, and touch devices
        link.addEventListener('click', (e) => {
          const href = link.getAttribute('href');
          if (!href || href === '#' || href === 'javascript:;' || href === 'javascript:void(0);') {
            e.preventDefault();
            item.classList.toggle('is-active');
            this.updateMenuState();
          }
        });

        // Hover support
        item.addEventListener('mouseenter', () => {
          item.classList.add('is-active');
          this.classList.add('menu-active');
        });
        item.addEventListener('mouseleave', () => {
          item.classList.remove('is-active');
          this.updateMenuState();
        });
      });

      if (this.menu) {
        this.menu.addEventListener('mouseenter', () => {
          this.classList.add('menu-active');
        });
        this.menu.addEventListener('mouseleave', () => {
          this.updateMenuState();
        });
      }

      if (this.backdrop) {
        this.backdrop.addEventListener('click', () => {
          this.items.forEach(item => item.classList.remove('is-active'));
          this.classList.remove('menu-active');
          if (this.header && this.header.classList.contains('open-menu')) {
            this.header.classList.remove('open-menu');
          }
        });
      }

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.items.forEach(item => item.classList.remove('is-active'));
          this.classList.remove('menu-active');
          if (this.header && this.header.classList.contains('open-menu')) {
            this.header.classList.remove('open-menu');
          }
        }
      });

      // Close on escape
      document.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') {
          this.items.forEach(item => item.classList.remove('is-active'));
          this.classList.remove('menu-active');
          if (this.header) {
            this.header.classList.remove('open-menu');
          }
        }
      });
    }
    updateMenuState() {
      const anyActive = this.querySelector('.full-menu--item.is-active');
      if (!anyActive && (!this.menu || !this.menu.matches(':hover'))) {
        this.classList.remove('menu-active');
      }
    }
    onToggleClick(e) {
      if (e) e.preventDefault();
      if (this.header) {
        this.header.classList.toggle('open-menu');
      }
    }
  }
  customElements.define('full-menu', FullMenu);
}